/**
 * Enumeration of all pages
 */
export enum Page {
    /** Represents the CanvasComponent */
    Canvas = "canvas",

    Safe = "safe",
    Fusebox = "fusebox",
    UseOwnName = "use-own-name",
};
